import apiFetch from '@scale/frontend-lib/api-fetch';
import { useAsync } from 'react-use-v13';
import { INamedObjectTypes } from '@scale/shared/types/lookup';

const objectCache: Record<string, Promise<any>> = {};
export function useObjectPreview<T>(
  id: string,
  type: INamedObjectTypes,
): { value?: T; loading: boolean; error?: any } {
  return useAsync(async () => {
    const promise =
      objectCache[id] ||
      apiFetch<T>(null, `corp-api/lookup/preview/${type}/${id}`, {
        method: 'GET',
      });
    objectCache[id] = promise;
    return await promise;
  }, [id, type]);
}
